import ptBrTranslations from "./pt-BR";
import ptEsTranslations from "./es";
import ptUsTranslations from "./us";

export default {
	"pt-BR": ptBrTranslations,
	es: ptEsTranslations,
	us: ptUsTranslations,
};
